function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 4.58512C3 4.22368 3.19504 3.89036 3.51015 3.71331L9.62076 0.279924C9.92952 0.106444 10.307 0.10921 10.6132 0.287196L16.5026 3.71079C16.8105 3.88981 17 4.21912 17 4.57532V9.99995L20 12.5V19C20 19.5522 19.5523 20 19 20L13 20V15L10 13L7 15V20L1 20C0.447715 20 0 19.5522 0 19V12.5L3 9.99995V4.58512ZM15 5.99995H13V8.99995H15V5.99995ZM9 5.99995H11V8.99995H9V5.99995ZM5 15H2V18H5V15ZM15 15H18V18H15V15ZM7 5.99995H5V8.99995H7V5.99995Z",
  fill: "currentColor"
});

var SvgRealEstate = function SvgRealEstate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRealEstate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/real-estate.cd2ac543.svg";
export { ForwardRef as ReactComponent };